import { startCase } from 'lodash';

import { AppEscrowDueFragment, AppEscrowSettingFragment, TaxEscrowType } from '@willow/graphql-iso/src/app';

import { assertNever } from './assertNever';

export function formatEscrowType(escrowDue: AppEscrowDueFragment, escrowSetting?: AppEscrowSettingFragment): string {
  switch (escrowDue.__typename) {
    case 'InsuranceEscrowDue':
      return startCase(escrowDue.insuranceName ?? 'Insurance');
    case 'TaxEscrowDue':
      return formatTaxEscrowType(escrowDue.taxType, escrowSetting);
    case 'MortgageInsuranceEscrowDue':
      return 'Mortgage Insurance';
    default:
      assertNever(escrowDue);
  }
}

export function formatTaxEscrowType(taxEscrowType: TaxEscrowType, escrowSetting?: AppEscrowSettingFragment) {
  switch (taxEscrowType) {
    case TaxEscrowType.CityTax:
      return 'City Tax';
    case TaxEscrowType.CountyTax:
      return 'County Tax';
    case TaxEscrowType.SchoolTax:
      return 'School Tax';
    case TaxEscrowType.TownTax:
      return 'Town Tax';
    case TaxEscrowType.VillageTax:
      return 'Village Tax';
    case TaxEscrowType.OtherTax:
      return escrowSetting?.payee ? startCase(escrowSetting.payee.name) : 'Other Tax';
    default:
      assertNever(taxEscrowType);
  }
}
